import React, { FC } from 'react';

import { Col, Row } from 'antd';
import { FormattedMessage } from 'react-intl';

export type CampaignLabelStatus = 'completed' | 'error' | 'plain';

interface OwnProps {
  bottomLabel?: {
    label: string;
    style: CampaignLabelStatus;
  };
  children: JSX.Element;
  description?: string;
  icon?: string;
  id?: string;
  isBlocked?: boolean;
  points?: string; // * TODO: Set icon as prop of every "resource" in "IChallengeResourceConfig"
  styleClass?: string;
  title: string;
}

const ChallengeResourceWrapper: FC<OwnProps> = ({
  bottomLabel,
  children,
  description,
  icon,
  id,
  points,
  styleClass,
  title,
}) => {
  return (
    <>
      <Row
        align="top"
        className={`challengeResourceWrapper ${styleClass} `}
        id={id}
        justify="center"
      >
        <div className="challengeResourceWrapper__blocked-overlay" />

        <Col className="challengeResourceWrapper__container">
          {icon && (
            <Row justify="center" className="challengeResourceWrapper__icon">
              <div className={`icon icon--${icon}`} />
            </Row>
          )}
          {points && (
            <Row
              justify="center"
              align="middle"
              className="challengeResourceWrapper__points"
            >
              <div className="icon icon--puntos" />
              {points}
            </Row>
          )}
          {title && (
            <Row justify="center" className="challengeResourceWrapper__title">
              {title}
            </Row>
          )}
          {description && (
            <Row
              className="challengeResourceWrapper__description"
              justify="center"
            >
              <p
                className="regular-body"
                dangerouslySetInnerHTML={{ __html: description }}
              ></p>
            </Row>
          )}
          {children}
          {bottomLabel && (
            <Row justify="center" align="middle">
              <div
                className={`challengeResourceWrapper__label challengeResourceWrapper__label--${bottomLabel.style}`}
              >
                <FormattedMessage id={bottomLabel.label} />
              </div>
            </Row>
          )}
        </Col>
      </Row>
    </>
  );
};

export default ChallengeResourceWrapper;

export const ChallengeResourceWrapperBlocked: FC<{}> = () => {
  return (
    <Row
      align="middle"
      justify="center"
      className="challengeResourceWrapper__blocked-icon"
    >
      <img className="icon icon--padlock--blocked-module icon__size-120" />
    </Row>
  );
};
